import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaintenanceService, MaintenanceStatus } from 'src/app/core/services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-maintenance-info-banner',
  templateUrl: './maintenance-info-banner.component.html',
  styleUrls: ['./maintenance-info-banner.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class MaintenanceInfoBannerComponent implements OnInit, OnDestroy {
  maintenanceStatus: MaintenanceStatus | null = null;
  showBanner: boolean = true;
  private statusSubscription?: Subscription;

  constructor(private maintenanceService: MaintenanceService) {}

  ngOnInit() {
    this.statusSubscription = this.maintenanceService.maintenanceStatus$.subscribe(
      status => {
        this.maintenanceStatus = status;
      }
    );
  }

  ngOnDestroy() {
    if (this.statusSubscription) {
      this.statusSubscription.unsubscribe();
    }
  }

  get displayMessage(): string {
    return this.maintenanceStatus?.message || 'Wartungsarbeiten sind geplant';
  }

  get updatedAt(): string | null {
    if (!this.maintenanceStatus?.updated_at) return null;
    return new Date(this.maintenanceStatus.updated_at).toLocaleString('de-AT');
  }

  closeBanner() {
    this.showBanner = false;
  }
}